module.exports = __webpack_public_path__ + "static/media/logos-facebook.4be26f98.svg";